import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { formatDB } from "../../../components/Utils/Currency";
import { useMutation } from "react-query";
import TransactionDeliveryService from "../../../Services/TransactionDelivery";
import { handleError } from "../../../components/Utils/Utils";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";
import NewImageUploader from "../../../components/NewImageUploader";

const FormCompleteDelivery = (props) => {
  const { delivery, isShow, onClose, refetch } = props;
  const delivery_group = delivery?.delivery_groups
    ? delivery?.delivery_groups[0] || ""
    : "";

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });

  const watchFields = watch();

  const mutationPostManualNotify = useMutation(
    TransactionDeliveryService.postManualNotify,
    {
      onError: (error, variables) => {
        handleError(error);
      },
      onSuccess: (data, variables) => {
        notifUtils("Success Update Delivery State", "success");
        refetch();
        onClose();
      },
    }
  );

  const onSubmit = (data) => {
    data.delivery_st = "COMPLETED";
    if (data?.estimate_fee) {
      data.estimate_fee = parseFloat(formatDB(data.estimate_fee));
    }
    mutationPostManualNotify.mutate(data);
  };

  React.useEffect(() => {
    reset({});
    if (delivery_group !== "") {
      setValue("delivery_id", delivery_group?.delivery_id);
      setValue("delivery_recipient", {
        name: "",
        phone: "",
        vehicle: "",
      });
    }
  }, [delivery_group]);

  return (
    <Modal
      isOpen={isShow}
      toggle={onClose}
      backdrop={false}
      size="lg"
      centered={true}
      zIndex={1300}
      modalClassName="modal-custom"
    >
      <ModalHeader toggle={onClose}>Complete Delivery</ModalHeader>
      <ModalBody>
        <form id="hook-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-4">
            <div className="row">
              <div className="col-12">
                <label className="font-12 font-bold d-flex justify-content-between align-items-center">
                  <span>Recipient</span>
                </label>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group mb-4">
                  <label
                    htmlFor="delivery_recipient-name"
                    className="font-12 font-bold d-flex justify-content-between align-items-center"
                  >
                    <span>Name</span>
                    <span className="font-bold text-muted">
                      {watchFields["delivery_recipient"]
                        ? watchFields["delivery_recipient"]["name"]?.length || 0
                        : 0}{" "}
                      / 100
                    </span>
                  </label>
                  <input
                    type="text"
                    id="delivery_recipient-name"
                    name="delivery_recipient.name"
                    className="form-control rounded-8px"
                    {...register("delivery_recipient.name", {
                      required: "Please input recipient name",
                      maxLength: {
                        value: 100,
                        message: "Maximum character 100",
                      },
                    })}
                  />
                  {errors?.delivery_recipient &&
                    errors?.delivery_recipient?.name && (
                      <small className="form-text text-error">
                        {errors?.delivery_recipient?.name?.message}
                      </small>
                    )}
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group mb-4">
                  <label
                    htmlFor="delivery_recipient-relationship"
                    className="font-12 font-bold d-flex justify-content-between align-items-center"
                  >
                    <span>Relationship</span>
                    <span className="font-bold text-muted">
                      {watchFields["delivery_recipient"]
                        ? watchFields["delivery_recipient"]["relationship"]
                            ?.length || 0
                        : 0}{" "}
                      / 50
                    </span>
                  </label>
                  <input
                    type="text"
                    id="delivery_recipient-relationship"
                    name="delivery_recipient.relationship"
                    className="form-control rounded-8px"
                    {...register("delivery_recipient.relationship", {
                      required: "Please input relationship",
                      maxLength: {
                        value: 50,
                        message: "Maximum character 50",
                      },
                    })}
                  />
                  {errors?.delivery_recipient &&
                    errors?.delivery_recipient?.relationship && (
                      <small className="form-text text-error">
                        {errors?.delivery_recipient?.relationship?.message}
                      </small>
                    )}
                </div>
              </div>
              <div className="col-12">
                <label className="font-12 font-bold">Delivery Photo (Potrait)</label>
                <Controller
                  render={({ field }) => (
                    <NewImageUploader
                      {...field}
                      compID={`delivery_photo`}
                      maxSize={5120}
                      background="#fafafa"
                      aspectRatio={4 / 5}
                      width={1080}
                      height={1350}
                      ratioParams="width"
                      size="auto"
                      useCropper={false}
                      image={watchFields["delivery_photo"] || ""}
                      onUploadDone={(value) =>
                        setValue(`delivery_photo`, value)
                      }
                      onRemove={() => setValue(`delivery_photo`, "")}
                      errorNote={
                        errors && errors?.delivery_photo
                          ? errors?.delivery_photo?.message || ""
                          : ""
                      }
                    />
                  )}
                  name={`delivery_photo`}
                  control={control}
                  rules={{
                    required: "Please upload delivery photo",
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <div className="d-block form-group text-right">
          <button
            type="button"
            className="btn btn-default border-0 mr-3"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="hook-form"
            className="btn btn-blue border-0"
          >
            Complete
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default FormCompleteDelivery;
